(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie"]) return;
  try {
    
  const cookieBox = document.querySelector(".wrapper"),
        buttons = document.querySelectorAll(".button");

  const executeCodes = () => {
    // Check if 'cookieBy' cookie exists
    if (document.cookie.split('; ').find(row => row.startsWith('cookieBy='))) return;

    cookieBox.classList.add("show");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        cookieBox.classList.remove("show");

        // Set cookie on accept or decline
        if (button.id === "acceptBtn" || button.id === "declineBtn") {
          document.cookie = "cookieBy=accepted; max-age=" + 60 * 60 * 24 * 30; // 30 days
        }
      });
    });
  };

  window.addEventListener("load", executeCodes);

  } catch(e) { console.error(e); }
})();
})();
